
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const FeaturedSlider = () => {
  const projectslider = {
    loop:true,
    margin:13,
    dots: false,
    autoplay:true,
    autoplayTimeout:2000,
    autoplayHoverPause:false,
    mouseDrag: true,
    responsive:{
        0:{
            items:1,
            stagePadding:5,
            dots:true,
        }, 
        480:{
            items:1,
            stagePadding:5,
            dots:true,
        },
        577:{
            items:1,
            stagePadding:5,
            dots:true,
        },
        767:{
            items:2,
            stagePadding:5,
            dots:true,
        },
        992:{
            items:5,
            stagePadding:0,
        }
    }
}
  return (
    <>  
    <OwlCarousel  className="owl-carousel" {...projectslider}>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book1.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book2.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book3.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book4.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book5.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book6.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book7.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book8.jpg" alt=""/>
          </div>
          <div className="feature-item">
              <img className="img-fluid" src="./assets/img/books/book9.jpg" alt=""/>
          </div>
          
    </OwlCarousel>
  
    </>
  );
};
export default FeaturedSlider;